module.exports = __webpack_public_path__ + "static/media/location-pin-colored.f7943f20.svg";